import { CORE, Category, LANGUAGE_TRANSLATION } from "./SurveyModels";

export enum RESOURCE_TYPE {
  CASE_HISTORY = "CASE_HISTORY",
  PROJECTS = "PROJECTS",
  DOCUMENT = "DOCUMENT",
  SUPPORT = "SUPPORT",
  MICROLEARNING = "MICROLEARNING",
  ELEARNING = "ELEARNING",
  HELP = "HELP",
}
export enum ROLE_FILTER {
  HR = "HR",
  MANAGER = "MANAGER",
  EMPLOYEE = "EMPLOYEE",
}

export interface PopulatedResource {
  id: string;
  translations: {
    language: LANGUAGE_TRANSLATION | string;
    title: string;
    description: string;
    link?: string;
  }[];
  type?: RESOURCE_TYPE;
  category: Category;
  roles: ROLE_FILTER[];
  enabled: boolean;
  isIssueLinked: boolean;
  nLikes: number;
  createdAt?: Date | string;
}

export enum ResourceImage {
  CASE_HISTORY = "case-history",
  PROJECTS = "special-projects",
  DOCUMENT = "dispense",
  ELEARNING = "e-learning",
  MICROLEARNING = "learning-beats",
  SUPPORT = "consultancy",
  HELP = "dispense",
}

export enum ResourceBackgroundColor {
  ELEARNING = "#7A8EF1",
  MICROLEARNING = "#415DEB",
  SUPPORT = "#344ABC",
  CASE_HISTORY = "#C6CEF9",
  PROJECTS = "#27388D",
  DOCUMENT = "#1A255E",
  HELP = "#FF3378",
}

export interface ResourcePayload {
  translations: {
    language: LANGUAGE_TRANSLATION | string;
    title: string;
    description: string;
    link?: string;
  }[];
  type?: RESOURCE_TYPE;

  categoryId?: string;
  roles?: ROLE_FILTER[];
}

export const initialResource: ResourcePayload = {
  translations: [
    {
      language: "",
      title: "",
      link: "",
      description: "",
    },
  ],
};

export const resourceType: { [key: string]: string }[] = Object.keys(
  RESOURCE_TYPE
).map((key) => ({
  [key]: RESOURCE_TYPE[key as keyof typeof RESOURCE_TYPE],
}));
